import React from 'react';

function Tip() {
  return (
    <div className="identical_product_tip">
      해당 상품의 {"'"}판매가격{"'"}과 {"'"}배송비{"'"}를 합산한 최저가
      상품들입니다.
    </div>
  );
}

export default Tip;
